/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OntologyNodeDetailRequest {
    getFixupPrototypeFunction() { return OntologyNodeDetailRequest.fixupPrototype; }

    static newInstance(model: Partial<OntologyNodeDetailRequest>): OntologyNodeDetailRequest {
        let obj = Object.assign(new OntologyNodeDetailRequest(), model);
        OntologyNodeDetailRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OntologyNodeDetailRequest>): OntologyNodeDetailRequest {
        if (!model) return null;
        return OntologyNodeDetailRequest.newInstance(<OntologyNodeDetailRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OntologyNodeDetailRequest) {
        if (!obj) return;

        models.OntologyNodeDetailRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OntologyNodeDetailRequest): boolean {
        Object.setPrototypeOf(obj, OntologyNodeDetailRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant the node belongs to
     */
    tenant_id: string;

    /**
     * Node identifier, as returned by the tree or node/items endpoint
     */
    node_id: string;

}
